import $api from "..";
import {AxiosResponse} from "axios";
import { IGetNotifications } from "../common/api_interfaces/notifications/IGetNotifications";
import { IRespNotification } from "../common/api_interfaces/notifications/IRespNotification";

export default class NotificationService {
    async getNotifications(body: IGetNotifications): Promise<AxiosResponse<IRespNotification>> {
        return $api.post<IRespNotification>('/getNotifications', body);
    }

    async checkNotificationViewed(body: number[]): Promise<AxiosResponse<any>> {
        return $api.post<any>('/checkNotificationViewed', body);
    }
}